
import { useRedux, useToggle } from "hooks";
import Footer from "layouts/Footer";
import RightSidebar from "layouts/RightSidebar";
import Topbar from "layouts/Topbar";
import React, { Suspense, useEffect } from "react";
import { Container, Navbar, Row } from "react-bootstrap";

import * as layoutConstants from 'appConstants';

import { Outlet } from "react-router-dom"
import { showRightSidebar, hideRightSidebar, changeSidebarType } from '../../redux/actions';
import LeftSidebar from "layouts/LeftSidebar";

const loading = () => <div className="text-center"></div>;

const ProfileMenu = () => {

    const { dispatch, appSelector } = useRedux();

    const [isMenuOpened, toggleMenu] = useToggle();

    useEffect(() => {
        dispatch(changeSidebarType(layoutConstants.SideBarWidth.LEFT_SIDEBAR_TYPE_CONDENSED));
    },[])

    const openMenu = () => {
        toggleMenu();
        if (document.body) {
            if (isMenuOpened) {
                document.body.classList.remove('sidebar-enable');
            } else {
                document.body.classList.add('sidebar-enable');
            }
        }
    };

    const { layoutColor, leftSideBarTheme, leftSideBarType, layoutWidth } = appSelector((state) => ({
        layoutColor: state.Layout.layoutColor,
        layoutWidth: state.Layout.layoutWidth,
        leftSideBarTheme: state.Layout.leftSideBarTheme,
        leftSideBarType: state.Layout.leftSideBarType,
    }));

    const isCondensed = leftSideBarType === layoutConstants.SideBarWidth.LEFT_SIDEBAR_TYPE_CONDENSED;
    const isLight = leftSideBarTheme === layoutConstants.SideBarTheme.LEFT_SIDEBAR_THEME_LIGHT;

    return(<>
        <div className="wrapper">
            <Suspense fallback={loading()}>
                <LeftSidebar isCondensed={isCondensed} isLight={isLight} hideUserProfile={true} />
            </Suspense>
            <div className="content-page pb-0">
                <div className="content">
                    <Suspense fallback={loading()}>
                        <Topbar openLeftMenuCallBack={openMenu} hideLogo={true} />
                    </Suspense>
                    <Container fluid>
                        <Outlet />
                    </Container>
                </div>
            </div>
        </div>
        <Suspense fallback={loading()}>
            <RightSidebar />
        </Suspense>
    </>)

}

export default ProfileMenu;

function dispatch(arg0: any) {
    throw new Error("Function not implemented.");
}
